(function(){
  // menu mobile
  var b=document.getElementById('burger'), n=document.getElementById('nav');
  if(b&&n) b.addEventListener('click',function(){
    var open=n.classList.toggle('is-open');
    b.setAttribute('aria-expanded',open?'true':'false');
  });
  // galerie produit
  var main=document.getElementById('galMain'), th=document.getElementById('galThumbs');
  if(main&&th) th.addEventListener('click',function(e){
    var btn=e.target.closest('button'); if(!btn) return;
    main.src=btn.dataset.full;
    th.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-current',x===btn?'true':'false');});
  });
  // quantite
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-qty]'); if(!btn) return;
    var input=btn.parentNode.querySelector('input[name="quantity"]'); if(!input) return;
    var v=parseInt(input.value||'1',10)+parseInt(btn.dataset.qty,10);
    input.value=v<1?1:v;
  });
})();
